import { Chip } from "@nextui-org/react";
import { formatCurrency, formatDateTime } from "@/utils/helpers";
import RowView from "../../components/Table/components/RowView";
import Button from "@/components/Button";
import usePermission from "../../../../hooks/usePermission";

function LectureView({ lecture }) {
    const {
        id,
        name,
        brief,
        price,
        visibility,
        courseId,
        createdAt,
        updatedAt,
    } = lecture;

    const { can } = usePermission();

    return (
        <>
            <div>
                <RowView title={name} brief={brief} />
                <RowView
                    name={"السعر "}
                    brief={formatCurrency(price)}
                    className={"flex"}
                />
                <RowView
                    className={"flex"}
                    name={"كود الكورس "}
                    brief={`${courseId}#`}
                />

                <RowView
                    className={"flex"}
                    name={"تاريخ الانشاء"}
                    brief={
                        <>
                            <span>
                                {" "}
                                الساعه :{" "}
                                {formatDateTime(createdAt).formattedTime}
                            </span>
                            <span>
                                {" "}
                                يوم : {formatDateTime(createdAt).formattedDate}
                            </span>
                        </>
                    }
                />
                {createdAt !== updatedAt && (
                    <RowView
                        name={"اخر تحديث"}
                        brief={
                            <>
                                <span>
                                    {" "}
                                    الساعه :{" "}
                                    {formatDateTime(updatedAt).formattedTime}
                                </span>
                                <span>
                                    {" "}
                                    يوم :{" "}
                                    {formatDateTime(updatedAt).formattedDate}
                                </span>
                            </>
                        }
                        className={"flex"}
                    />
                )}
                <RowView
                    className={"flex"}
                    name={"الحاله"}
                    brief={
                        <Chip
                            className="gap-1 capitalize border-none text-default-600"
                            color={visibility ? "success" : "warning"}
                            size="md"
                            variant="dot"
                        >
                            {visibility == 1 ? "مفعل" : "غير مفعل"}
                        </Chip>
                    }
                />
            </div>
            {can("read:course:lecture:items") && (
                <div className="flex gap-2 mt-3">
                    <Button
                        name="go to the course lectures page"
                        to={`${id}/lectureStudents`}
                        type="customized"
                        className="flex-1 h-10 2xl:h-10 flex justify-center items-center text-[15px] font-semibold leading-none tracking-wide text-center text-white transition-colors duration-300 rounded-full 2xl:text-[18px] bg-secondary-color hover:bg-[#1C3A5C]  focus:bg-[#1C3A5C] focus:outline-none focus:ring focus:ring-yellow-300 focus:ring-offset-2 disabled:cursor-not-allowed"
                    >
                        الدخول لطلاب المحاضره
                    </Button>
                    <Button
                        name="go to the course lectures page"
                        to={`${id}`}
                        type="customized"
                        className="flex-1 h-10 2xl:h-10 flex justify-center items-center text-[15px] font-semibold leading-none tracking-wide text-center text-white transition-colors duration-300 rounded-full 2xl:text-[18px] bg-secondary-color hover:bg-[#1C3A5C]  focus:bg-[#1C3A5C] focus:outline-none focus:ring focus:ring-yellow-300 focus:ring-offset-2 disabled:cursor-not-allowed"
                    >
                        الدخول لتفاصيل المحاضره
                    </Button>
                </div>
            )}
        </>
    );
}

export default LectureView;
